import { CdkMenuItem } from '@angular/cdk/menu';
import { Component, computed, ElementRef, inject, input, InputSignal, OutputRef, Signal, ChangeDetectionStrategy } from '@angular/core';
import { outputFromObservable } from '@angular/core/rxjs-interop';
import { MatRipple } from '@angular/material/core';
import { NavItemModel } from '@libs/shared/models';
import { NavLinkDirective } from '@libs/shared/ui';
import { fromEvent } from 'rxjs';

@Component({
  selector: 'ui-menu-item',
  imports: [MatRipple, NavLinkDirective],
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  hostDirectives: [CdkMenuItem],
})
export class MenuItemComponent {
  public item: InputSignal<NavItemModel> = input.required();
  public isActive: InputSignal<boolean> = input(false);
  public level: InputSignal<number> = input(0);

  public readonly selectBeforeNavigate: OutputRef<MouseEvent> = outputFromObservable(
    fromEvent<MouseEvent>(inject<ElementRef<HTMLElement>>(ElementRef).nativeElement, 'click', { capture: true }),
  );

  public levelClass: Signal<string> = computed(()=> this.level() !== 0 ? `lvl level-${this.level()}` : '');
}
